export default __webpack_public_path__ + "static/media/splashCircle.98469a64.png";